import React from 'react';
import type { MedicalConsultation } from '../../../types/api';

const LABELS: Record<string, { label: string; cls: string }> = {
  draft: { label: 'Borrador', cls: 'custom-badge status-orange' },
  signed: { label: 'Firmado', cls: 'custom-badge status-green' },
  amended: { label: 'Enmendado', cls: 'custom-badge status-blue' },
};

interface ConsultationStatusBadgeProps {
  status: MedicalConsultation['status'];
  signatureMethod?: MedicalConsultation['signature_method'];
}

/**
 * clinical-record-signing status badge, shown on the list, detail and edit
 * pages (task 3.3). Falls back to the draft look for a missing status so an
 * older cached response never silently looks "signed".
 */
const ConsultationStatusBadge: React.FC<ConsultationStatusBadgeProps> = ({ status, signatureMethod }) => {
  const entry = LABELS[status ?? 'draft'] ?? LABELS.draft;
  const label = status === 'signed' && signatureMethod === 'delegated'
    ? 'Firmado por delegación'
    : entry.label;

  return <span className={entry.cls}>{label}</span>;
};

export default ConsultationStatusBadge;
